import React from 'react'

import { DataConnectionSyncDetailPopup } from 'features/DataConnections/DataConnectionsManager/DataConnectionSyncDetailPopup'

import { Button } from 'ui/components/Button'
import { Icon } from 'ui/components/Icon'
import { Spinner } from 'ui/components/Spinner'

import { useToolbarActionsSyncState } from './hooks/useToolbarActionsSyncState'

type ToolbarActionsSyncProps = {}

export const ToolbarActionsSync: React.FC<ToolbarActionsSyncProps> = () => {
    const {
        isOpen,
        onOpenChange,
        integrationId,
        earliestStatus,
        dataConnections,
        isVisible,
        buttonLabel,
        buttonLabelColor,
        status,
        onForceFullSync,
        showSyncButton,
    } = useToolbarActionsSyncState()

    if (!isVisible) return null

    return (
        <DataConnectionSyncDetailPopup
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            integrationId={integrationId!}
            earliestStatus={earliestStatus}
            dataConnections={dataConnections}
            modal={false}
            asChild={true}
            innerContent={
                showSyncButton && (
                    <Button
                        variant="secondary"
                        size="s"
                        startIcon={{ name: 'RefreshCcw' }}
                        onClick={onForceFullSync}
                    >
                        Force full re-sync
                    </Button>
                )
            }
        >
            <Button variant="ghost" size="xs" style={{ color: buttonLabelColor }}>
                {status === 'in-progress' && (
                    <Spinner size="2xs" role="presentation" color="default" />
                )}
                {status === 'finished' && <Icon name="Check" size="s" />}
                {status === 'error' && <Icon name="X" size="s" />}
                {buttonLabel}
            </Button>
        </DataConnectionSyncDetailPopup>
    )
}
